// extracted by mini-css-extract-plugin
export default {"wrapper":"GetService_wrapper__lCP2p","Service":"GetService_Service__+2l-8","item-wp":"GetService_item-wp__uyXFe"};